import isObject from 'lodash/isObject'
import { isInlineElement } from "../../../utils/queries"
import { getNormalTextElement } from "../../Element/paragraph/utils"
import { jsx } from 'slate-hyperscript'
import cloneDeep from 'lodash/cloneDeep'


const doesFragmentHaveOnlyTr = (fragment) => {
  if(!Array.isArray(fragment) || !fragment.length) return false
  return fragment.every(child => child.type === 'tr')
}
export const preInsert = (editor, fragment) => {
  if (doesFragmentHaveOnlyTr(fragment)) {
    const rows = fragment?.length
    const cols = fragment?.[0]?.children?.length ?? 1
    const colWidths = Array(cols).fill(250)
    
    const tbody = jsx('element', { type: 'tbody' }, fragment)
    const table = jsx('element', { type: 'table', attrs: { rows, cols, colWidths } }, tbody)

    fragment = [table]
  }
  const firstNodeType = fragment[0]?.type || undefined
  if (firstNodeType && !isInlineElement(fragment[0]) && firstNodeType !== 'fragment' && firstNodeType !== 'p') {
    fragment.unshift(getNormalTextElement())
    fragment.push(getNormalTextElement())
  }
  return fragment
}

export const preInsertTable = (fragment, editorChildrenLength) => {
  if(editorChildrenLength === 1) fragment.unshift(getNormalTextElement())
  fragment.push(getNormalTextElement())
}

export const applyDirty = (fragment) => {
  if (!fragment) return;

  if (Array.isArray(fragment)) {
    return fragment.forEach(applyDirty);
  }

  if (!isObject(fragment) || !fragment['children']) return;

  // add dirty attrs
  if (!fragment['attrs']) fragment['attrs'] = {};
  fragment['attrs']['dirty'] = true;
  applyDirty(fragment['children']);
}

export const getCustomToolbarComponents = (editor, ELEMENT_TAGS) => {
  let FILTERED_ELEMENT_TAGS = cloneDeep(ELEMENT_TAGS);

  const isCustomRte = editor.customToolbarComponents?.['v2.element']?.length || editor.customToolbarComponents?.['v2.leaf']?.length || editor.customToolbarComponents?.['v2.editorButtons']?.length;
  
  let customToolbarComponents = [];

  if (isCustomRte) {
    customToolbarComponents = [
      ...editor?.customToolbarComponents?.["v2.editorButtons"],
      ...editor?.customToolbarComponents?.["v2.element"],
      ...editor?.customToolbarComponents?.["v2.leaf"]
    ]

    Object.keys(FILTERED_ELEMENT_TAGS).forEach((key) => {
      if (!customToolbarComponents.includes(key.toLowerCase())) {
        delete FILTERED_ELEMENT_TAGS[key]
      }
      //added this as all the other table elems defined below are dependent on the TABLE component
      if (customToolbarComponents.includes('table')) {
        const tableElements = {
          THEAD: (el) => ({ type: 'thead', attrs: {} }),
          TBODY: (el) => ({ type: 'tbody', attrs: {} }),
          TR: (el) => ({ type: 'tr', attrs: {} }),
          TD: (el) => ({ type: 'td', attrs: {} }),
          TH: (el) => ({ type: 'th', attrs: {} })
        }
        FILTERED_ELEMENT_TAGS = { ...FILTERED_ELEMENT_TAGS, ...tableElements }
      }
    })
  }

  return [isCustomRte, customToolbarComponents, FILTERED_ELEMENT_TAGS]
}